/**
 * Port of the DS `CountBadge`. Ground is --hp-danger (#B23A2E, white 12px =
 * 5.94:1) — not a generic red, which fails contrast. Renders nothing at 0.
 * The caller positions it.
 */
export interface CountBadgeProps {
  count: number;
  max?: number;
  className?: string;
}

export function CountBadge({ count, max = 99, className }: CountBadgeProps) {
  if (!(count > 0)) return null;
  return (
    <span
      className={`flex h-5 min-w-5 items-center justify-center rounded-full bg-danger px-1 font-body text-xs font-bold leading-none text-white ${className ?? ''}`}
    >
      {count > max ? `${max}+` : count}
    </span>
  );
}
